import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common'; // Asegúrate de importar CommonModule

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { AlertService } from '../../../core/services/alert/alert.service';
import { DocumentsService } from '../../../core/services/documents/documents.service';
import { DocumentsTypeService } from '../../../core/services/documentType/documents-type.service';
import { FilterSelectTypesPipe } from '../../../core/pipe/custom-pipes';
import { LocalStorageService } from '../../../core/services/localStorage/local-storage.service';
import { AuthStateService } from '../../../core/services/auth-state/auth-state-service.service';
import Swal from 'sweetalert2';
interface FileItem {
  file: File;
  selectOption: string;
  key: string;
}
interface FormConfig {
  reference: any;
  documents: any;
  private_documents: any;
  label: string;
  type: any;
  ruleId: any;
  documentFunction?: any;
  allDocumentFunction?: any;
}

@Component({
  selector: 'app-form-add-document',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    FilterSelectTypesPipe,
  ],
  templateUrl: './form-add-document.component.html',
  styleUrl: './form-add-document.component.css',
})
export class FormAddDocumentComponent implements OnChanges {

  @Output() backButtonClickDocument = new EventEmitter<boolean>();
  @Output() addDocuments = new EventEmitter<boolean>();
  @Output() formSubmit = new EventEmitter<any>();
  @Output() formSubmitStage = new EventEmitter<any>();
  @Output() filesArrayChanged: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() goDocs = new EventEmitter<any>();

  account_type = this.authStateService.getAccountType();

  @Input() clientData?: any;
  @Input() campaignData?: any;
  @Input() orderData?: any;
  @Input() guaranteeData?: any;
  @Input() invoiceData?: any;

  @Input() activeForm?: any;
  @Input() selectTypes?: any;
  @Input() ladata: any = {};
  @Input() rules: any = {};

  @Input() btn_submit?: any;

  existingDocuments: any[] = [];
  showExistingDocuments = false;

  orderDocumentType: string = 'type';

  isDisabled: boolean = true;
  label: string = 'client';
  varSelectType = 'orders';
  uploadFile = true;

  formConfigs: { [key: string]: FormConfig } = {};




  activeDocumentTab: number = 0; // Índice del tab activo
  showDocument: string = 'public'; // Tipo de documento a mostrar
  tabs: { title: string; key: string }[] = []; // Definición de los tabs


  constructor(
    private alertService: AlertService,
    private documentService: DocumentsService,
    private documentTypeService: DocumentsTypeService,
    private localStorageService: LocalStorageService,
    private authStateService: AuthStateService,
    private translateService: TranslateService
  ) {
/*     var flag = this.authStateService.getRole() != 'Logistics' && this.authStateService.getRole() != 'Workshop' ? true : false;
    var flag2 = this.authStateService.getAccountType() != 'broker' ? true : false
    if (flag) {
      this.tabs = [
        { title: 'public', key: 'public' },
        { title: 'private', key: 'private' }
      ];
    } else {
      this.tabs = [
        { title: 'private', key: 'private' }
      ];
    }
 */
  }

  ngOnInit() {
    this.getTypes();
  }

  getTypes(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.documentTypeService.getSelectType().subscribe({
        next: (data) => {
            this.selectTypes = data.data;
          resolve();
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activeForm'] || changes['rules'] || changes['orderData'] || changes['clientData'] || changes['guaranteeData'] || changes['invoiceData'] || changes['campaignData']) {
      this.rules = this.loadRules();
      this.resetFormState();
      this.formConfigs = {
        client: {
          reference: this.clientData?.reference,
          documents: this.clientData?.documents,
          private_documents: this.clientData?.private_documents,
          label: 'client',
          type: this.clientData?.type,
          ruleId: this.rules?.client_id,
          documentFunction: this.documentService.getClientDocuments.bind(
            this.documentService
          ),
        },
        assignee: {
          reference: this.clientData?.reference,
          documents: this.clientData?.documents,
          private_documents: this.clientData?.private_documents,
          label: 'assignee',
          type: this.clientData?.type,
          ruleId: this.rules?.client_id,
          documentFunction: this.documentService.getClientDocuments.bind(
            this.documentService
          ),
        },
        'doc-campaign' :{
          reference: this.campaignData?.reference,
          documents: this.campaignData?.documents,
          private_documents: this.campaignData?.private_documents,
          label: 'campaign',  
          type: 'campaign',
          ruleId: this.rules?.documents,
          documentFunction: this.documentService.getCampaignDocuments.bind(
            this.documentService
          ),
        },
        guarantee: {  
          reference: this.guaranteeData?.reference,
          documents: this.guaranteeData?.documents,
          private_documents: this.guaranteeData?.private_documents,
          label: 'guarantee',
          type: this.guaranteeData?.type,
          ruleId: this.rules?.guarantee_id,
          documentFunction: this.documentService.getClientDocuments.bind(
            this.documentService
          ),
        },
        invoice: {
          reference: this.invoiceData?.reference,
          documents: this.invoiceData?.documents,
          private_documents: this.invoiceData?.private_documents,
          label: 'invoice',
          type: 'invoice',
          ruleId: null,
          documentFunction: this.documentService.getinvoiceDocuments.bind(
            this.documentService
          ),
        },
        'doc-order': {
          reference: this.orderData?.reference,
          documents: this.orderData?.documents,
          private_documents: this.orderData?.private_documents,
          label: 'order',
          type: 'order',
          ruleId: this.rules?.documents,
          documentFunction: this.documentService.getOrderDocuments.bind(
            this.documentService
          ),
          allDocumentFunction: this.documentService.downloadAllDocuments.bind(
            this.documentService
          ),
        },
      };
      this.configureTabsAndDocuments();
    }
  }

  private loadRules(): any {
    switch (this.activeForm) {
      case 'doc-campaign':
        return this.campaignData?.rules;
      case 'doc-order':
      case 'client':
      case 'assignee':
      case 'guarantee':
      return this.orderData?.rules;
     
      case 'invoice':
        return this.invoiceData?.rules;
      default:
        return this.orderData?.rules;
    }
  }

  private resetFormState(): void {
    this.files = [];
    this.showExistingDocuments = false;
    this.existingDocuments = [];
    this.isDisabled = true;
  }

 private updateFormState(config: FormConfig | undefined): void {
   if (config && config.reference) {
    if (this.showDocument === 'public') {
      this.existingDocuments = config.documents || [];
    } else {
      this.existingDocuments = config.private_documents || []
    }

    this.isDisabled = false;
    this.label = config.label;
    this.varSelectType = config.type;
      this.uploadFile = true;

    if (config.ruleId === 'r') {
      this.uploadFile = false;
    }

    this.showExistingDocuments = this.existingDocuments.length > 0;
  }
}

 isWorkshopUser: boolean = false;

 setActiveTab(index: number) {
  if (this.isWorkshopUser) {
    console.log('Workshop user cannot change tabs');
    return;
  }

  this.activeDocumentTab = index;
  this.showDocument = this.tabs[index].key;

  const config = this.formConfigs[this.activeForm];
  if (config) {
    if (this.showDocument === 'public') {
      this.existingDocuments = config.documents || [];
    } else {
      this.existingDocuments = config.private_documents || [];
    }
    this.showExistingDocuments = this.existingDocuments.length > 0;
  }

}

  getDocuments() {
    const config = this.formConfigs[this.activeForm];
      if (config && config.reference && config.documentFunction) {
        this.alertService.loading('swal_messages.search_documents');
        config.documentFunction(config.reference).subscribe({
          next: (data: any) => {
            this.updateFormConfigsWithFreshData(data.data);
            if (this.showDocument === 'public') {
              this.existingDocuments = data.data.documents || [];
            } else {
              this.existingDocuments = data.data.private_documents || [];
            }

            this.showExistingDocuments = this.existingDocuments.length > 0;
            this.alertService.close();
          },
          error: (error: any) => {
            this.existingDocuments = [];
            this.alertService.close();
          },
        });
      } else {
        this.alertService.close();
      }
  }

private updateFormConfigsWithFreshData(data: any): void {
  if (this.formConfigs[this.activeForm]) {
    this.formConfigs[this.activeForm].documents = data.documents || [];
    this.formConfigs[this.activeForm].private_documents = data.private_documents || [];
  }

  this.updateParentData(data);
}

private updateParentData(data: any): void {
  switch (this.activeForm) {
    case 'doc-order':
      if (this.orderData) {
        this.orderData.documents = data.documents || [];
        this.orderData.private_documents = data.private_documents || [];
      }
      break;
    case 'client':
      if (this.clientData) {
        this.clientData.documents = data.documents || [];
        this.clientData.private_documents = data.private_documents || [];
      }
      break;
    case 'guarantee':
      if (this.guaranteeData) {
        this.guaranteeData.documents = data.documents || [];
        this.guaranteeData.private_documents = data.private_documents || [];
      }
      break;
    case 'invoice':
      if (this.invoiceData) {
        this.invoiceData.documents = data.documents || [];
        this.invoiceData.private_documents = data.private_documents || [];
      }
      break;
    case 'doc-campaign':
      if (this.campaignData) {
        this.campaignData.documents = data.documents || [];
        this.campaignData.private_documents = data.private_documents || [];
      }
      break;
  }
}
  emitBackButtonClick() {
    this.files = [];
    this.existingDocuments = [];
    this.filesArrayChanged.emit(this.files);
    this.backButtonClickDocument.emit(true);
  }

  emitAddDocuments() {
    this.addDocuments.emit(true);
  }

  onSubmit() {
    const isValid = this.checkSelectOptionDiversity(this.files);

    if (!isValid) {
      this.alertService.error('swal_messages.document_type_excess');
    } else {
      this.alertService.loading(
        'Por favor espera mientras se añaden los documentos.'
      );

      const formData = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        formData.append(`file[${i}]`, this.files[i].file);
        formData.append(`type[${i}]`, this.files[i].selectOption);
      }
      formData.append('visibility', this.showDocument);
      switch (this.activeForm) {
        case 'guarantee':
          formData.append('client_id', this.guaranteeData.reference);
          break;
        case 'assignee':
        case 'client':
          formData.append('client_id', this.clientData.reference);
          break;
        case 'invoice':
          formData.append('invoice_id', this.invoiceData.reference);
          break;
        case 'doc-order':
          formData.append('order_id', this.orderData.reference);
          break;
           case 'doc-campaign':
          formData.append('campaign_id', this.campaignData.reference);
          break;
      }

      this.documentService.addDocument(formData).subscribe({
        next: (data) => {
          if (data.data.next_stage != null) {
            this.files = [];
            const stageTranslation = this.translateService.instant(`badge-status_select-stage.${data.data.next_stage}`);
            const messageWithParams = this.translateService.instant('swal_messages.change_stage_message', { stage: stageTranslation });
            const title = this.translateService.instant('swal_messages.change_stage');
            const confirmButtonText = this.translateService.instant('swal_messages.confirm');
            const cancelButtonText = this.translateService.instant('swal_messages.notes.cancel');

            this.alertService
              .confirmation2(
                messageWithParams,
                title,
                confirmButtonText,
                cancelButtonText)
              .then((result) => {
                if (result.isConfirmed) {
                  this.alertService.loading('swal_messages.please_wait');
                  this.formSubmitStage.emit(data.data.next_stage);
                  this.alertService.close();
                }
              });
          } else {
            this.alertService
              .successOk('swal_messages.add_document_success')
              .then((result) => {
                if (result.isConfirmed) {
                  this.files = [];
                  this.filesArrayChanged.emit(this.files);
                  this.getDocuments();
                }
              });
          }
        },
        error: (error) => {
          this.alertService.error(error.error).then((result) => {
            if (result.isConfirmed) {
            }
          });
        },
      });
    }
  }

  downloadAllDocuments() {
    this.alertService.loading('swal_messages.please_wait_documents');
    const config = this.formConfigs[this.activeForm];
    if (config && config.reference && config.documentFunction) {
      config.allDocumentFunction(config.reference).subscribe({
        next: (data: any) => {
          let url = data.data.zip_url;
          const a = document.createElement('a');
          a.href = url;
          a.click();
          this.alertService.close();
        },
        error: (error: any) => {
          this.alertService.close();
        },
      });
    } else {
      // Manejar el caso en el que activeForm no sea ninguno de los valores esperados
      this.alertService.close();
    }
  }

  downloadScopedDocuments(scope: 'order' | 'client' | 'guarantee') {
    const reference = this.orderData?.reference;
    if (!reference) return;

    this.alertService.loading('swal_messages.please_wait_documents');
    this.documentService.downloadScopedDocuments(reference, scope).subscribe({
      next: (data: any) => {
        const a = document.createElement('a');
        a.href = data.data.zip_url;
        a.click();
        this.alertService.close();
      },
      error: (error: any) => {
        this.alertService.close();
        if (error.status === 404) {
          this.alertService.warning('swal_messages.orders.no_documents');
        } else {
          this.alertService.error(error.error);
        }
      },
    });
  }

  seeFile(reference: any) {
    // Buscar el documento por su referencia
    const document = this.existingDocuments.find(doc => doc.reference === reference);
    
    if (document && document.file) {
      // Usar Google Docs Viewer para visualizar el archivo sin descargarlo
      const fileUrl = encodeURIComponent(document.file);
      const viewerUrl = `https://docs.google.com/viewer?url=${fileUrl}&embedded=true`;
      
      // Abrir en una nueva pestaña con el visor
      window.open(viewerUrl, '_blank');
    } else {
      // Si no se encuentra el archivo, mostrar un mensaje de error
      this.alertService.error('swal_messages.file_not_found');
    }
  }

  deleteFile(reference: any) {
    this.alertService
      .confirmation(
        'swal_messages.warning_confirm',
        'swal_messages.delete_document',
        'swal_messages.confirm'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.alertService.loading(
            'swal_messages.please_wait'
          );

          this.documentService.deleteDocument(reference).subscribe({
            next: (data) => {
              this.alertService
                .successOk('swal_messages.delete_document_success')
                .then((result) => {
                  if (result.isConfirmed) {
                    this.getDocuments();
                  }
                });
            },
            error: (error) => {
              this.alertService.error(error.error).then((result) => {
                if (result.isConfirmed) {
                }
              });
            },
          });
        }
      });
  }

  generateFilledPdf(reference: any) {
    this.alertService.loading('swal_messages.please_wait');

    this.documentService.generateFilledPdf(reference).subscribe({
      next: (response: any) => {
        if (response.success && response.data?.pdf_url) {
          window.open(response.data.pdf_url, '_blank');
          this.alertService.close();
          this.alertService.successOk('swal_messages.pdf_generated_success');
          this.getDocuments();
        } else {
          this.alertService.close();
          this.alertService.error('Error: No PDF URL received');
        }
      },
      error: (error) => {
        this.alertService.close();
        this.alertService.error(error.error || 'Error generating PDF');
      },
    });
  }

  checkSelectOptionDiversity(
    data: Array<{ file: any; selectOption: string; key: string }>
  ): boolean {
    if (data.length <= 3) {
      return true; // Si hay 3 o menos elementos, no hay restricciones.
    }
    // Contar las ocurrencias de cada `selectOption`.
    const optionCounts: Record<string, number> = {};
    data.forEach((item) => {
      const option = item.selectOption;
      optionCounts[option] = (optionCounts[option] || 0) + 1;
    });

    // Verificar si algún `selectOption` excede el 70 %.
    const total = data.length;
    for (const option in optionCounts) {
      if (optionCounts['other'] && optionCounts['other'] / total >= 0.7) {
        return false;
      }
    }
    return true; // Si no hay ningún `selectOption` con el 70 % o más, cumple.
  }

  changeForm(form: string) {
    this.activeForm = form;
    this.getDocuments();
  }

  orderDocs(type: string) {
    this.orderDocumentType = type;
    this.sortDocumentsByDate(this.orderDocumentType);

  }

  sortDocumentsByDate(type: string) {
    if (type == 'type') {
      this.existingDocuments = this.existingDocuments.sort((a, b) => {
        return a.type.localeCompare(b.type);
      });
    }
    if (type == 'date_asc') {
      this.existingDocuments = this.existingDocuments.sort((a, b) => {
        return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
      });
    }
    if (type == 'date_desc') {
      this.existingDocuments = this.existingDocuments.sort((a, b) => {
        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
      });
    }
  }

  //--------------------------------------------------------------------
  //------------------IMGDRAG AND DROP STUFF----------------------------
  //--------------------------------------------------------------------

  @Output() filesDropped = new EventEmitter<FileList>();
  files: FileItem[] = [];

  actualizarArchivos(nuevosArchivos: any[]) {
    this.files = nuevosArchivos;
    this.filesArrayChanged.emit(this.files);
  }

  private getEntity(): string {
    switch (this.activeForm) {
      case 'doc-order': return 'orders';
      case 'invoice': return 'invoices';
      case 'doc-campaign': return 'campaigns';
      default: return 'clients';
    }
  }

  private processFilesWithSuggestion(uniqueFiles: File[], rawFiles?: FileList) {
    if (uniqueFiles.length === 0) return;

    const entity = this.getEntity();
    const names = uniqueFiles.map(f => f.name);

    this.alertService.loading('swal_messages.please_wait');
    this.documentTypeService.suggestType(entity, names).subscribe({
      next: (response) => {
        this.alertService.close();
        const suggestions: any[] = response.data || [];
        const crossEntityMap: { [suggestedEntity: string]: string[] } = {};

        uniqueFiles.forEach((file, index) => {
          const suggestion = suggestions[index];
          let selectOption = 'defaultOption';

          if (suggestion) {
            selectOption = suggestion.type && suggestion.type !== 'unknown' ? suggestion.type : 'defaultOption';

            if (!suggestion.matches_requested_entity && suggestion.entity) {
              if (!crossEntityMap[suggestion.entity]) {
                crossEntityMap[suggestion.entity] = [];
              }
              crossEntityMap[suggestion.entity].push(file.name);
            }
          }

          const newFileItem: FileItem = {
            file: file,
            selectOption: selectOption,
            key: selectOption,
          };
          this.files.push(newFileItem);
        });

        this.filesArrayChanged.emit(this.files);

        const suggestedEntities = Object.keys(crossEntityMap);
        if (suggestedEntities.length > 0) {
          const translatedCurrentEntity = this.translateService.instant('entities.' + entity);
          const sections = suggestedEntities.map(suggestedEntity => {
            const fileList = crossEntityMap[suggestedEntity].join(', ');
            const translatedSuggestedEntity = this.translateService.instant('entities.' + suggestedEntity);
            return this.translateService.instant('swal_messages.document_types.cross_entity_warning', {
              files: fileList,
              suggested_entity: translatedSuggestedEntity,
              current_entity: translatedCurrentEntity
            });
          });
          const msg = sections.join('<br><br>');
          Swal.fire({
            title: this.translateService.instant('swal_messages.warning'),
            html: msg,
            icon: 'warning',
            confirmButtonColor: '#ffc107',
            confirmButtonText: 'OK',
          });
        }
      },
      error: () => {
        this.alertService.close();
        uniqueFiles.forEach((file) => {
          const newFileItem: FileItem = {
            file: file,
            selectOption: 'defaultOption',
            key: 'defaultOption',
          };
          this.files.push(newFileItem);
        });
        this.filesArrayChanged.emit(this.files);
      },
    });

    if (rawFiles) {
      this.filesDropped.emit(rawFiles);
    }
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleHighlight(event, false);

    const newFiles = event.dataTransfer?.files;
    if (newFiles && newFiles.length > 0) {
      const uniqueFiles = Array.from(newFiles).filter(
        (file) => !this.files.some((f) => f.file.name === file.name && f.file.size === file.size)
      );
      this.processFilesWithSuggestion(uniqueFiles, newFiles);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleHighlight(event, true);
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleHighlight(event, false);
  }

  private toggleHighlight(event: DragEvent, isOver: boolean) {
    const target = event.target as HTMLElement;
    if (target) {
      target.classList.toggle('over', isOver);
    }
  }

  isImage(file: File): boolean {
    return file.type.startsWith('image/');
  }

  getThumbnailSrc2(name: string): string {
    const patterns = {
      jpg: /\.(jpg|jpeg|png)$/i,
      pdf: /\.pdf$/i,
      doc: /\.(docx?|dotx?)$/i,
      xls: /\.(xls?|xlsx?)$/i,
      zip: /\.zip$/i,
    };

    for (const [key, pattern] of Object.entries(patterns)) {
      if (pattern.test(name)) {
        return `../../../assets/icons/${key}.svg`;
      }
    }

    return '../../../assets/icons/file.svg';
  }

  getThumbnailSrc3(file: File): string {
    const patterns = {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      pdf: 'application/pdf',
      doc: 'application/msword',
      csv: 'text/csv',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      xslx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'word-openxml':
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      xls: 'application/vnd.ms-excel',
      'xls-openxml':
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    };

    for (const [key, mimeType] of Object.entries(patterns)) {
      if (file.type === mimeType) {
        switch (key) {
          case 'jpg':
          case 'jpeg':
          case 'png':
            return `../../../assets/icons/jpg.svg`;
            break;
          case 'pdf':
            return `../../../assets/icons/pdf.svg`;
            break;
          case 'word-openxml':
          case 'doc':
          case 'docx':
            return `../../../assets/icons/doc.svg`;
            break;
          case 'xls-openxml':
          case 'xls':
            return `../../../assets/icons/xls.svg`;
            break;
          default:
            return '../../../assets/icons/file.svg';
            break;
        }
      }
    }
    return '../../../assets/icons/file.svg';
  }

  getThumbnailSrc(file: File): string {
    const mimeToIcon: Record<string, string> = {
      'image/jpeg': '../../../assets/icons/jpg.svg',
      'image/png': '../../../assets/icons/jpg.svg',
      'application/pdf': '../../../assets/icons/pdf.svg',
      'application/msword': '../../../assets/icons/doc.svg',
      'text/csv': '../../../assets/icons/file.svg',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '../../../assets/icons/doc.svg',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '../../../assets/icons/xls.svg',
      'application/vnd.ms-excel': '../../../assets/icons/xls.svg'
    };

    return mimeToIcon[file.type] || '../../../assets/icons/file.svg';
  }

  onFileInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const newFiles = input.files;
    if (newFiles && newFiles.length > 0) {
      const uniqueFiles = Array.from(newFiles).filter(
        (file) => !this.files.some((f) => f.file.name === file.name && f.file.size === file.size)
      );
      this.processFilesWithSuggestion(uniqueFiles, newFiles);
    }
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
  }

  selectOptionChanged(event: Event, index: number) {
    const selectElement = event.target as HTMLSelectElement;
    const option = selectElement.value;
    this.files[index].selectOption = option;
  }

  pickAColor(type: string): string {
    const colorMap: Record<string, string> = {
      'identification': '#f0ab96',
      'organization_identification': '#f0ab96',
      'offer': '#f0ab96',

      'payroll': '#f0d3b1',
      'company_deed': '#f0d3b1',
      'offer_signed': '#f0d3b1',

      'employment_record': '#a7cce0',
      'ownership': '#a7cce0',
      'contract_signed': '#a7cce0',

      'bank_account_ownership': '#9daff0',
      'balance': '#9daff0',
      'guarantee_contract': '#9daff0',

      'receipt': '#c19fc2',
      'p_and_l': '#c19fc2',
      'guarantee_contract_signed': '#c19fc2',

      'pension_revaluation': '#f5f3a8',
      '200_organization_income_tax_return': '#f5f3a8',
      'delivery_certificate': '#f5f3a8',

      '037_census_declaration': '#ded9d5',
      '303_vat_return': '#ded9d5',
      'contract': '#ded9d5',

      '100_income_tax_return': '#8db99e',
      '390_vat_summary': '#8db99e',

      '130_quaterly_income_tax_return': '#4fc3c2',
      '131_quaterly_income_tax_return': '#a2d4df',

      'aux1': '#eaa3b5',
      'aux2': '#c2dbbe',
      'axu3': '#f9f6c1',
      'aux4': '#f7bd98'
    };

    return colorMap[type] || '#d0e5e8';
  }

  getDownloadName(documentName: string): string {
    // Aquí puedes personalizar el nombre de descarga como desees
    const timestamp = new Date().getTime();
    return `${documentName}_${timestamp}.pdf`; // Cambia la extensión según el tipo de archivo
  }

  emitgoDocs() {
    this.goDocs.emit(true);
  }


  /************************ */


   private configureTabsAndDocuments(): void {
    const role = this.authStateService.getRole();
    const accountType = this.authStateService.getAccountType();
    this.isWorkshopUser = (role === 'Workshop');


    // Configurar tabs según el rol
    if (this.isWorkshopUser) {
      // ✅ WORKSHOP: Solo tab "internos" (private)
      this.tabs = [{ title: 'private', key: 'private' }];
      this.activeDocumentTab = 0;
      this.showDocument = 'private';
    } else if (role === 'Logistics') {
      // Logistics: Solo tab "internos"
      this.tabs = [{ title: 'private', key: 'private' }];
      this.activeDocumentTab = 0;
      this.showDocument = 'private';
    } else {
      // Otros usuarios: Ambos tabs
      this.tabs = [
        { title: 'public', key: 'public' },
        { title: 'private', key: 'private' }
      ];
      this.activeDocumentTab = 0;
      this.showDocument = 'public';
    }
    // Actualizar el estado con la configuración correcta
    this.updateFormState(this.formConfigs[this.activeForm]);
  }


}
